import {
  QuoteItemRequestParams,
  QuoteItemsSearchRequestParams,
  QuoteItemCoverageSearchRequestParams,
} from '@lio/api-types';

export const quoteItemQueryKey = {
  get: ['quoteItem'] as const,
  getWithParams: (params: QuoteItemRequestParams) =>
    [...quoteItemQueryKey.get, params.quoteId, params.quoteItemId] as const,
  search: ['quoteItems'] as const,
  searchWithParams: (params: QuoteItemsSearchRequestParams) => [...quoteItemQueryKey.search, params.quoteId] as const,
  updateQuoteItemAttributesMutationKey: ['quote-item-attributes'] as const,
  searchQuoteItemCoverages: (params: QuoteItemCoverageSearchRequestParams) => [
    'quote',
    params.quoteId,
    'quote-item-coverage',
  ],
};
